import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'

import CityImage from 'assets/images/cities/icons/city.svg'

import SessionMenu from 'js/components/layout-menu/_session-menu.js'
import AddressInfo from 'js/components/address-info/index.js'
import ComplaintsBook from 'js/components/complaints-book/index.js'
import FollowUs from 'js/components/follow-us/index.js'
import ContactMixin from 'js/mixins/contact-modal-mixin'

import HelpLinks from './_help-links.js'

import template from './index.pug'

/** @todo Refactor to extend from core */

// @vue/component
export default Vue.extend({
  name: 'sidebar-menu-cust-gc',
  template: template(),
  components: {
    SessionMenu, AddressInfo, ComplaintsBook, FollowUs, HelpLinks
  },

  mixins: [ContactMixin],

  props: {
    controlMenu: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      destinations: {
        privacyPolicy: 'https://autgc.org/politica-de-privacidad/',
        cookiesPolicy: 'https://autgc.org/cookie-policy-eu/',
        dataSessionAndHandling: 'https://autgc.org/politica-de-privacidad/'
      }
    }
  },

  computed: {
    municipalityIcon() {
      if (this.currentMunicipality) {
        return this.currentMunicipality.image_url || CityImage
      }
      return undefined
    }
  },

  methods: {
    ...mapActions(['openLanguageModal']),

    closeMenu() {
      this.$emit('close-menu')
    },

    logout() {
      this.closeMenu()
      this.$emit('logout')
    },

    login() {
      this.closeMenu()
      this.$emit('login')
    },

    register() {
      this.closeMenu()
      this.$emit('register')
    },

    goToTransportRequest() {
      this.$router.push({
        name: 'transport-request'
      })
    },

    goToPrivacyPolicy() {
      const url = 'https://autgc.org/aviso-legal/'
      window.open(url)
    },

    goToGeneralConditionsOfTransport() {
      const url = 'https://autgc.org/movilidad/'
      window.open(url)
    },

    goToCookiesPolicyText() {
      const url = 'https://autgc.org/cookie-policy-eu/'
      window.open(url)
    },

    goInstitutionalInformation() {
      const url = 'https://autgc.org/el-consorcio/'
      window.open(url)
    },

    goTo(destination) {
      const url = this.destinations[destination]
      window.open(url)
    },

    openLanguageSelector() {
      this.closeMenu()
      this.openLanguageModal()
    },

    openContactModalInt() {
      this.closeMenu()
      this.openContactModal()
    }

  }
})
